import { combineLatest, forkJoin, isObservable, Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

// Uncomment the comments to dump calls with list of booleans and source file:line

export function combineLogicalAnd(...args: any[]): Observable<boolean> {
  let booleans$ = <Observable<boolean>[]>args.map(a => !isObservable(a) ? of(a) : a);

  return combineLatest(...booleans$).pipe(
    map(x => x.length ? !x.some(x => !x) : true)
  );
}

export function combineLogicalOr(...args: any[]): Observable<boolean> {
  let booleans$ = <Observable<boolean>[]>args.map(a => !isObservable(a) ? of(a) : a);

  return combineLatest(...booleans$).pipe(
    map(x => x.length ? x.some(x => x) : true)
  );
}

export function combineForLoading(...args: any[]): Observable<boolean> {
  let booleans$ = <Observable<boolean>[]>args.map(a => !isObservable(a) ? of(a) : a);

  return combineLatest(...booleans$).pipe(
    map(x => x.some(x => x)),
    startWith(true),
  );
}

